import { Dimensions } from "react-native";

const { width } = Dimensions.get("window");

export default {
	isMobile: width < 600,
	isWeb: 600 <= width <= 1600,
	isLargeScreen: 1600 <= width,
};
